/**
 * Extract trigger string from the original one
 * @param {String} input
 * @returns {TriggerProps}
 */
const extractTrigger = (input) => {
  /** "rest": String, "original": String */
  const map = new Map();
  const split = input.split(":");

  const original = split.length > 1 ? split[0] : "initial";
  const rest = split.length > 1 ? split[1] : input;

  map.set("original", original);
  map.set("rest", rest);

  return map;
}

export default extractTrigger;